import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  handleSwitchChange(e) {
    e.preventDefault();
    e.target.form.requestSubmit();
    e.target.blur();
  }
}
